import React, {Component} from "react";
import Button from "./Button";

export default function SimpleButton({
  className,
  secondary,
  styles,
  children,
  onClick,
  text,
  icon,
  category,
  ...props
}) {
  const color = secondary ? "btn-back" : "btn-plus background-red";
  return (
      <>
          {category === "action_button" ?
              (
                  <Button
                      className={`btnAct ${className}`}
                      style={{height: "40px", ...styles}}
                      onClick={onClick}
                      {...props}
                  >
                      {icon && <span>{icon}</span>}
                  </Button>
              ) :
              (
                  <Button
                      className={`btn ${color} margin-left-15px ${className}`}
                      style={{ width: "130px", height: "40px", ...styles }}
                      onClick={onClick}
                      {...props}
                  >
                    {icon && <span>{icon}</span>}
                    {text && <span>{text}</span>}
                    {children}
                  </Button>)
          }
      </>
  );
}

const ButtonText = (props) => {
  const {children} = props;
  return (
      <span>
        {children}
      </span>
  )
}

const ButtonIcon = (props) => {
  return (
      <span>
        <i {...props} className={`${props.className}`}></i>
      </span>
  )
}

SimpleButton.Text = ButtonText
SimpleButton.Icon = ButtonIcon
